import { create } from "zustand";

export type ExclusiveSurface =
  | "tour"
  | "announcement"
  | "walkthrough"
  | "catalog"
  | "callout"; // OperationBar just-in-time coachmark

interface CanShowMap {
  suggestion: boolean;
  tour: boolean;
  announcement: boolean;
}

interface OnboardingStore {
  activeSurface: ExclusiveSurface | null;
  canShow: CanShowMap;
  claim: (s: ExclusiveSurface) => void;
  release: (s: ExclusiveSurface) => void;
}

const USER_INITIATED: ReadonlySet<ExclusiveSurface> = new Set(["walkthrough", "catalog"]);

export const useOnboardingStore = create<OnboardingStore>((set) => ({
  activeSurface: null,
  canShow: {
    suggestion: true,
    tour: false,
    announcement: true,
  },
  claim: (s) =>
    set((state) => {
      if (state.activeSurface === null) return { activeSurface: s };
      if (USER_INITIATED.has(s)) return { activeSurface: s };
      return {};
    }),
  release: (s) =>
    set((state) => (state.activeSurface === s ? { activeSurface: null } : {})),
}));
